// extracted by mini-css-extract-plugin
export default {"container":"IntroductionPaper_container__6DCOh","textBlock":"IntroductionPaper_textBlock__5q0aI","buttonContainer":"IntroductionPaper_buttonContainer__iL-mu"};